import Circle from '@src/sld/components/Circle/Circle';
import HorizontalLine from '@src/sld/components/Line/HorizontalLine';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import { Resistor } from '@src/sld/components/Resistor/Resistor';
import { DataPointWithValue } from '@src/types/DataPoint';
import { ReactElement, useMemo } from 'react';
import RTACRectangle from './RTACRectangle';

type TopSwitchResistorProps = {
  translateXCoordinate: number;
  translateYCoordinate: number;
  rtacDataPointsWithValues: DataPointWithValue[];
};

function TopSwitchResistorSection(props: TopSwitchResistorProps): ReactElement {
  const { translateXCoordinate, translateYCoordinate } = props;
  const translate = `translate(${translateXCoordinate}, ${translateYCoordinate})`;
  const rtac52T1Value = useMemo(
    () =>
      props.rtacDataPointsWithValues.find(
        (dp) =>
          dp.pointName === '50BF52T1_PCB_52T1_Status' &&
          dp.sourceDeviceId === 'rtac_1',
      )?.value,
    [props.rtacDataPointsWithValues],
  );

  const fillColor =
    rtac52T1Value === 0 ? 'green' : rtac52T1Value === 1 ? 'red' : 'grey';

  return (
    <g transform={translate}>
      <Circle
        label=''
        translateXCoordinate={708}
        translateYCoordinate={10}
        diameter={3}
        stroke='white'
        strokeWidth={0.5}
        fillColor='black'
        overrideTextXCoordinate={-50}
      />

      <VerticalLine
        translateXCoordinate={708}
        translateYCoordinate={17}
        length={18}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />

      <VerticalLine
        translateXCoordinate={708}
        translateYCoordinate={35}
        length={14}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />
      <RTACRectangle
        label={'52T1'}
        xCoordinate={698}
        yCoordinate={50}
        labelXCoordinate={737}
        labelYCoordinate={65}
        fillColor={fillColor}
        textAnchor='middle'
      />

      <VerticalLine
        translateXCoordinate={708}
        translateYCoordinate={70}
        length={22}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />

      <g transform='rotate(90 700 783)'>
        <Resistor label='T1' />
      </g>

      <VerticalLine
        translateXCoordinate={708}
        translateYCoordinate={105}
        length={20}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />

      <VerticalLine
        translateXCoordinate={708}
        translateYCoordinate={125}
        length={50}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />

      <HorizontalLine
        translateXCoordinate={708}
        translateYCoordinate={155}
        color='white'
        width={0.5}
        length={20}
      />
      <Circle
        label='SCE - ION 8650'
        innerText='M'
        translateXCoordinate={739}
        translateYCoordinate={145}
        diameter={10}
        stroke='white'
        strokeWidth={0.5}
      />
    </g>
  );
}

export default TopSwitchResistorSection;
